import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  IEmptyRequestResponse,
  INotificationAppViewResponse,
  INotificationsAppViewRequest,
  IUpdateProfileSetupNotificationsRequest,
  IUpdateProfileSetupNotificationsResponse,
  IViewProfileSetupNotificationsResponse,
} from '@zeta-types';
import { NOTIFICATION_SERVICE } from '../services-path';

export const NotificationService = () => {
  return {
    createAdvisorNotification: (payload: IUpdateProfileSetupNotificationsRequest): APIResponse<IUpdateProfileSetupNotificationsResponse> =>
      HttpClient.post(`${NOTIFICATION_SERVICE}/centre/preference/advisorprofile/setup`, payload),

    viewAdvisorNotification: (payload: IEmptyRequestResponse): APIResponse<IViewProfileSetupNotificationsResponse> =>
      HttpClient.post(`${NOTIFICATION_SERVICE}/centre/preference/view`, payload),

    updateAdvisorNotification: (payload: IUpdateProfileSetupNotificationsRequest): APIResponse<IUpdateProfileSetupNotificationsResponse> =>
      HttpClient.post(`${NOTIFICATION_SERVICE}/centre/preference/default/update`, payload),

    notificationAppView: (payload: INotificationsAppViewRequest): APIResponse<INotificationAppViewResponse> =>
      HttpClient.post(`${NOTIFICATION_SERVICE}/app/view`, payload),

    markNotificationRead: (payload: { notificationIDs: Array<string>; isReadAll: boolean }): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${NOTIFICATION_SERVICE}/app/mark`, payload),
  };
};
